export default "__VITE_ASSET__BHWs9naD__"